import { Maybe } from 'yup/lib/types'

import { TokenType, Token } from 'api/domain/auth'

const ACCESS_TOKEN_KEY = 'accessToken'
const REFRESH_TOKEN_KEY = 'refreshToken'

export const selectAccessToken = (): Maybe<TokenType> => {
  let token = null
  try {
    const parsedToken = window.localStorage.getItem(ACCESS_TOKEN_KEY) || ''
    token = JSON.parse(parsedToken)
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return token
}

export const setTokenPair = (tokens: Token) => {
  window.localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(tokens?.access_token))
  // window.localStorage.setItem(REFRESH_TOKEN_KEY, JSON.stringify(tokens?.refresh_token))
}

export const clearTokens = () => {
  window.localStorage.setItem(ACCESS_TOKEN_KEY, '')
  window.localStorage.setItem(REFRESH_TOKEN_KEY, '')
}
export const logoutUser = () => {
  console.log('logoutUser')
}
// export const logoutUser = createAction<void>(`${AUTH_KEY_NAME}/logoutUser`)
